/*
 * cookie相关操作
 * from: atlas_v2
 * time: 2016-05-24
 * 备注： kirkzheng迁移
 */

const cookie = {};

/**
 * 设置一个cookie,还有一点需要注意的，在qq.com下是无法获取qzone.qq.com的cookie，反正qzone.qq.com下能获取到qq.com的所有cookie.
 * 简单得说，子域可以获取根域下的cookie, 但是根域无法获取子域下的cookie.
 * @param {String} name cookie名称
 * @param {String} value cookie值
 * @param {String} domain 所在域名，若不传，默认采用当前域名
 * @param {String} path 所在路径
 * @param {Number} hour 存活时间，单位:小时
 * @return {Boolean} 是否成功
 * @example
 *  $.cookie.set(key,value,"qzone.qq.com","/",24); //设置cookie
 */
cookie.set = function (name, value, domain, path, hour) {
  let expire;
  if (hour) {
    expire = new Date();
    expire.setTime(expire.getTime() + 3600000 * hour);
  } else if (typeof domain == 'object') {
    const opt = domain;
    domain = opt.domain;
    path = opt.path;
    expire = opt.expires;
  }
  document.cookie = `${name}=${value}; ${hour ? `expires=${expire.toGMTString()}; ` : ''}path=${path || '/'}; domain=${domain || document.domain};`;
  return true;
};

/**
 * 获取指定名称的cookie值
 * @param {String} name cookie名称
 * @return {String} 获取到的cookie值
 * @example
 *        $.cookie.get(key); //获取cookie
 */
cookie.get = function (name) {
  const r = new RegExp(`(?:^|;+|\\s+)${name}=([^;]*)`);
  const m = document.cookie.match(r);
  return !m ? '' : m[1];
};

/**
 * 删除指定cookie,复写为过期
 * @param {String} name cookie名称
 * @param {String} domain 所在域
 * @param {String} path 所在路径
 * @example
 *        $.cookie.del(key,'qzone.qq.com','/'); //删除cookie
 */
cookie.del = function (name, domain, path) {
  document.cookie = `${name}=; expires=Mon, 26 Jul 1997 05:00:00 GMT; path=${path || ''}; domain=${domain || document.domain};`;
};

export default cookie;
